import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/App'
// import {data} from '@/utils/data.js'  
const home = () =>
    import ('@/components/home.vue')
import glymenu from './glymenu'
Vue.use(Router)
const router = new Router({
    routes: [{　　　　　
            path: '/',
            　　　　　name: 'login',
            　　　　　meta: { title: '登陆' },
            component: () =>
                import ('@/components/Login.vue')
        },

        　　 {　　　　　
            path: '/home',
            　　　　　name: 'Home',
            　　　　　meta: { title: '智慧经纪人--首页', keepAlive: true },
            component: () =>
                import ('@/components/home.vue'),
            children: [],
            　　
        },
        {　　　　
            'path': '/menu',
            　　　　'name': 'menu',
            　　　　'meta': { title: '菜单' },
            component: () =>
                import ('@/components/menu.vue')
        },
        {　　　　
            'path': '/userInfor',
            　　　　'name': 'userInfor',
            　　　　'meta': { title: '个人资料' },
            component: () =>
                import ('@/components/userInfor.vue')
        },
        {　　　　
            'path': '/repassword',
            　　　　'name': 'repassword',
            　　　　'meta': { title: '修改密码' },
            component: () =>
                import ('@/components/repassword.vue')
        },
        {　　　　
            'path': '/systemMsg',
            　　　　'name': 'systemMsg',
            　　　　'meta': { title: '通知中心' },
            component: () =>
                import ('@/components/systemMsg.vue')
        },
        {
            path: '*',
            component: () =>
                import ('@/components/nofound.vue')
        }
    ]
});
// const router = new Router({
//     routes: defaultRouters
// }) 
if (sessionStorage.menu) {
    let data = JSON.parse(sessionStorage.menu);
    data.forEach(item => {
        // v.children.forEach(item=>{


        // 使用路由懒加载拼接路由路径获取组件  只适用于两级菜单   登陆页面的路由同理
        if (item.children && item.hasChildrenShow == 1) { //有子组件并且子组件要显示出来 父组件只是菜单 不能切换路由
            item.children.forEach(child => { //遍历子组件 ，将子组件作为一级路由
                let route = {}
                route.component = () =>
                    import (`@/components/${child.component}.vue`)
                route.path = '/' + child.path;
                if (child.redirect) {
                    route.redirect = child.redirect
                }
                if (child.children && child.children.length > 0) { //子组件下有子组件  不被显示在菜单中，只在页面中切换
                    route.children = child.children;
                    child.children.forEach(childer => {
                        childer.path = '/' + childer.path;
                        let childcomponents = `components/${childer.component}.vue`;
                        childer.component = () =>
                            import (`@/${childcomponents}`)
                    })
                }
                route.meta = {
                    title: child.meta.title
                }
                router.options.routes[1].children.push(route)
            })
        } else if (!item.children && item.hasChildrenShow != 1) { //没有子组件 直接将其放在一级路由
            let route = {}
            route.redirect = item.redirect;
            route.path = '/' + item.path;
            route.meta = {
                title: item.meta.title
            }
            route.component = () =>
                import (`@/components/${item.component}.vue`)
            router.options.routes[1].children.push(route)
        } else if (item.children && item.hasChildrenShow != 1) { //有子组件但是不在菜单中显示的情况 
            let route = {}
            route.path = '/' + item.path;
            route.redirect = item.redirect;
            route.meta = {
                title: item.meta.title
            }
            route.component = () =>
                import (`@/components/${item.component}.vue`)
            item.children.forEach(child => { //遍历子组件将component赋值正确路径
                let childcomponents = `components/${child.component}.vue`;
                child.component = () =>
                    import (`@/${childcomponents}`)
                child.path = '/' + child.path;
                child.meta = {
                    title: child.meta.title
                }
                child.routershow = child.hidden;
            })
            route.children = item.children;
            router.options.routes[1].children.push(route)
        }

        // })
    })
    router.addRoutes(router.options.routes)
}
export default router;